import { CircularProgress } from '@material-ui/core';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ItemContent from '../../../../components/ItemContent/ItemContent';
import { EPaths } from '../../../../types/enums/EPaths';
import { IEditForm } from '../../../../types/interfaces/IEditForm';
import { NSSupportReasons } from '../../../../types/interfaces/NSSupportReasons';
import { endpoints } from '../../../../utils/endpoints';
import StringsFormater from '../../../../utils/stringsFromater';
import tPaths from '../../../../utils/tPaths';
import useDescLangs from '../../../../utils/useDescLangs';

const FIELD_NAME = 'supportReasonsField';
const SupportReasons = ({ editable }: { editable: boolean }) => {
  const { languagesList, reduceLangsList } = useDescLangs();
  const { t } = useTranslation();

  const descriptionMapper = useCallback(
    (data: NSSupportReasons.IData, key: string): IEditForm[][] => {
      return [
        [
          {
            type: 'input',
            fieldName: FIELD_NAME,
            multiline: true,
            initialValue: new StringsFormater(data.supportReasons).merge(),
          },
        ],
      ];
    },
    [t],
  );

  const tabs = useMemo(
    () => [...languagesList.map((lang) => ({ key: lang.key, label: lang.display }))],
    [languagesList],
  );

  const tabsContentMapper = useCallback(
    (data: NSSupportReasons.IData) => ({
      ...languagesList.reduce(
        (acc, cv) => ({
          ...acc,
          [cv.key]: descriptionMapper(data, cv.key),
        }),
        {},
      ),
    }),
    [descriptionMapper, languagesList],
  );

  const updateDataFormatter = useCallback(
    (fields: any) => {
      const reasons = reduceLangsList(fields, FIELD_NAME);

      return {
        reasons: new StringsFormater([reasons[Object.keys(reasons)[0]]]).split(),
      };
    },
    [reduceLangsList],
  );

  return (
    <>
      {languagesList.length ? (
        <ItemContent
          path={EPaths.LegalLinks}
          title={t(tPaths.itemContent.supportReasons)}
          tabs={tabs}
          tabsContentMapper={tabsContentMapper}
          updateDataFormatter={updateDataFormatter}
          apiUrl={endpoints.supportReasons}
          backButton={false}
          editable={editable}
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default SupportReasons;
